import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./api";

const DataCtx = createContext(null);

export const DataProvider = ({ children }) => {
  const [lineas, setLineas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/lineas");
      setLineas(r.data);
      setError(null);
    } catch (e) {
      setError(e?.message || "Error cargando datos");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const origenDatos = lineas.length
    ? lineas.some((l) => l.origen_datos === "simulado") &&
      lineas.some((l) => l.origen_datos === "anteproyecto")
      ? "mixto"
      : lineas[0]?.origen_datos || "anteproyecto"
    : "anteproyecto";

  // Lista de concesiones (lotes) presentes dinámicamente en los datos cargados.
  const lotes = useMemo(() => {
    const set = new Set((lineas || []).map((l) => l.lote).filter(Boolean));
    return Array.from(set).sort();
  }, [lineas]);

  return (
    <DataCtx.Provider value={{ lineas, lotes, loading, error, refresh, origenDatos }}>
      {children}
    </DataCtx.Provider>
  );
};

export const useData = () => useContext(DataCtx);
